import {
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
    GET_PRICES_FOR_ITEMS,
    RESET_PRICES_FOR_ITEMS,
} from '../actions/actionTypes';

const initialState = {
    pricedItems: [],
    isPricingDone: false,
    pricesForItemsLoading: false,
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const getPricesForItemsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRICES_FOR_ITEMS:
            return {
                ...state,
                // pricedItems: [],
                isPricingDone: false,
                pricesForItemsLoading: true,
            };
        case GET_PRICES_FOR_ITEMS_SUCCESS:
            return {
                ...state,
                pricedItems: action.payload.items,
                isPricingDone: false,
                pricesForItemsLoading: false,
            };
        case GET_PRICES_FOR_ITEMS_FAILURE:
            return {
                ...state,
                pricedItems: action.payload.items,
                isPricingDone: false,
                pricesForItemsLoading: false,
            };
        case RESET_PRICES_FOR_ITEMS:
            return {
                ...state,
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentAddGetPricesForItemsKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    getPricesForItemsReducer
);
